<template>
  <div>
    <div>
      <div>
        <!-- 地图 -->
        <el-amap class="amap-box" :zoom="amap.zoom" :center="amap.center">
          <!-- 当前位置图标 -->
          <el-amap-marker
            v-for="(marker, index) in amap.markers"
            :key="'marker' + index"
            :position="marker.position"
          />
          <!-- 位置名称显示 -->
          <el-amap-text
            v-for="(marker, index) in amap.markers"
            :key="'text' + index"
            :text="marker.text"
            :offset="marker.offset"
            :position="marker.position"
          />
        </el-amap>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Map",
  data() {
    return {
      lng: 0,
      lat: 0,
      // 地图对象
      amap: {
        zoom: 8,
        center: [121.66136, 31.816837],
        markers: [
          {
            position: [121.66136, 31.816837],
            text: "永安广场校区",
            offset: [0, 30]
          },
          {
            position: [121.609429,32.054364],
            text: "吕四港校区",
            offset: [0, 30]
          },
          {
            position: [121.419521, 31.115737],
            text: "上海春申校区",
            offset: [0, 30]
          }
        ]
      }
    };
  },
  created() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.amap-box {
  height: 44vh;
}
.el-vue-search-box-container {
  // top: 45px;
  width: 100% !important;
}
.search-box {
  position: absolute;
  z-index: 5;
  width: 70%;
  left: 13%;
  top: 10px;
  height: 30px;
}

.search-box .el-input {
  float: left;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 0 7px 7px 0;
  outline: none;
  position: relative;
}

.search-box .el-button {
  position: absolute;
  right: 0;
  top: 1px;
  width: 20%;
  background: #38a28a;
  border-radius: 0 7px 7px 0;
  border: none;
  color: #fff;
  outline: none;
}

.tip-box {
  text-align: center;
  width: 100%;
  position: absolute;
  top: 35px;
  padding: 10px 0;
  background-color: #fff;
  opacity: 0.8;
}
</style>
